import Immutable from 'immutable';
import {
  ACTIVITY_INCIDENT_RECORD,
  GET_INCIDENT_RECORD,
  CLEAR_INCIDENT_RECORD,
  FLAG_ACTIVITY_INCIDENT_RECORD,
} from '../../../actions/types/supervision-control';

const INITIAL_STATE = Immutable.Map({
  incidentRecordActivity: Immutable.Map({
    loading: false,
  }),
  incidentRecord: Immutable.Map({
    content: Immutable.Map({}),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIVITY_INCIDENT_RECORD:
      return state.setIn(['incidentRecordActivity', 'loading'], action.payload);

    case FLAG_ACTIVITY_INCIDENT_RECORD:
      return state.setIn(['incidentRecord', 'loading'], action.payload);

    case GET_INCIDENT_RECORD:
      return state.setIn(
        ['incidentRecord', 'content'],
        Immutable.Map(action.payload),
      );

    case CLEAR_INCIDENT_RECORD:
      return state.setIn(['incidentRecord', 'content'], Immutable.Map({}));

    default:
      return state;
  }
};
